import { useEffect, useState } from "react";

const DEFAULT_MS = 220;

/** Monte/démonte avec délai pour laisser jouer la transition CSS. */
export function useModalTransition(open: boolean, durationMs = DEFAULT_MS) {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const frame = requestAnimationFrame(() => {
        requestAnimationFrame(() => setVisible(true));
      });
      return () => cancelAnimationFrame(frame);
    }

    setVisible(false);
    const timer = window.setTimeout(() => setMounted(false), durationMs);
    return () => window.clearTimeout(timer);
  }, [open, durationMs]);

  return { mounted, visible };
}

export const MAIL_MODAL_TRANSITION_MS = DEFAULT_MS;
